import { http } from '@/core/helpers/http.helper';
import { Communication } from '../../communications/communication.interface';
import { CompanyAddress } from '../company.interface';
import { ApiResource } from './../../../models/api-resource.interface';

export class AddressService {
   async postAddress(companyId: number, address: CompanyAddress, is_paginated?: boolean) {
      const response = await http.post<ApiResource<CompanyAddress>>(`/companies/${companyId}/addresses`, address, {
         params: { is_paginated },
      });
      return response.data;
   }
   async putAddress(companyId: number, addressId: number, address: CompanyAddress, is_paginated?: boolean) {
      const response = await http.put<ApiResource<CompanyAddress>>(`/companies/${companyId}/addresses/${addressId}`, address, {
         params: { is_paginated },
      });
      return response.data;
   }
   async deleteAddress(companyId: number, addressId: number, is_paginated?: boolean) {
      const response = await http.delete<ApiResource<CompanyAddress>>(`/companies/${companyId}/addresses/${addressId}`, {
         params: { is_paginated },
      });
      return response.data;
   }
   async call(companyId: number, addressId: number, hitId?: number) {
      const response = await http.get<ApiResource<Communication>>(`/companies/${companyId}/addresses/${addressId}/call/${hitId || ''}`);
      return response.data;
   }
   async inviteToVideoRoom(customerId: number, videocallRoomId: number, addressId: number) {
      const response = await http.get<ApiResource<Communication>>(
         `/companies/${customerId}/addresses/${addressId}/video-room/${videocallRoomId}/invite`,
      );
      return response.data;
   }
   async searchAddress(companyId: number, search: string) {
      const response = await http.get<ApiResource<CompanyAddress>>(`/companies/${companyId}/addresses`, { params: { search } });
      return response.data;
   }
}
